import script from "./LoginOrRequestAccess.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginOrRequestAccess.vue?vue&type=script&setup=true&lang=ts"

import "./LoginOrRequestAccess.vue?vue&type=style&index=0&id=64594506&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64594506"]])

export default __exports__